function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var _templateObject, _templateObject2;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { NjcButtonCard as p } from "../button-card.js";
import "../../chip/gator/chip.gator.js";
import "../../card/gator/base/card.gator.js";
import "../../card/gator/header/card-header.gator.js";
import "../../card/gator/content/card-content.gator.js";
import "../../card/gator/footer/card-footer.gator.js";
import "../../text-detail/gator/text-detail.gator.js";
import "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";
import { html as l } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";
import { LitElement as m } from "../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";
import u from "../../../packages/web-components/src/components/button-card/gator/button-card.gator.scss.js";
import b from "../../../packages/web-components/src/tokens/primitive.tokens.scss.js";
import g from "../../../packages/web-components/src/components/button-card/button-card.tokens.scss.js";
import f from "../../../packages/web-components/src/components/card/card.tokens.scss.js";
import { customElement as $ } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/decorators/custom-element.js";
import { ifDefined as n } from "../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/directives/if-defined.js";
import { KEY_CONSTANTS as c } from "../../../consts/key-constants.js";
import { unsafeCSS as i } from "../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/css-tag.js";
var v = Object.getOwnPropertyDescriptor,
  C = function C(t, a, h, o) {
    for (var e = o > 1 ? void 0 : o ? v(a, h) : a, r = t.length - 1, d; r >= 0; r--) (d = t[r]) && (e = d(e) || e);
    return e;
  };
var s = /*#__PURE__*/function (_p) {
  function s() {
    _classCallCheck(this, s);
    return _callSuper(this, s, arguments);
  }
  _inherits(s, _p);
  return _createClass(s, [{
    key: "render",
    value: function render() {
      return l(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            <ngc-card\n                tabindex=\"", "\"\n                role=\"button\"\n                aria-pressed=\"", "\"\n                ?elevated=\"", "\"\n                ?outlined=\"", "\"\n                @click=", "\n                @keydown=", "\n                ?disabled=\"", "\"\n                class=\"", "\"\n            >\n                ", "\n\n                <slot>\n                    <div class=\"gator-button-card-container ", "\">\n                        <ngc-text-detail\n                            title=\"", "\"\n                            subtitle=\"", "\"\n                            data-testid=", "-text-detail\n                        >\n                            <ngc-icon slot=\"append\" name=\"chevron-right\"></ngc-icon>\n                        </ngc-text-detail>\n                    </div>\n                </slot>\n            </ngc-card>\n        "])), this.disabled ? "-1" : "0", this.selected, this.elevated, this.outlined, this.handleClick, this.handleKeydown, this.disabled, this.selected ? "selected" : "", this.cardLabelMarkup, this.disabledClass, this.title, this.subtitle, n(this.dataTestid));
    }
  }, {
    key: "cardLabelMarkup",
    get: function get() {
      return this.chipLabel ? l(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n                <ngc-chip\n                    ?disabled=\"", "\"\n                    class=\"gator-button-card-chip-label\"\n                    data-testid=", "-chip\n                    readonly\n                >\n                    ", "\n                </ngc-chip>"])), this.disabled, n(this.dataTestid), this.chipLabel) : null;
    }
  }, {
    key: "disabledClass",
    get: function get() {
      return this.disabled ? "gator-button-card_disabled" : "";
    }
  }, {
    key: "handleClick",
    value: function handleClick(t) {
      t.preventDefault(), t.stopImmediatePropagation(), !this.disabled && this.dispatchEvent(new CustomEvent("click", {
        bubbles: !0
      }));
    }
  }, {
    key: "click",
    value: function click() {
      this.handleClick(new CustomEvent("click", {
        bubbles: !0
      }));
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(t) {
      [c.ENTER, c.SPACE].includes(t.key) && this.handleClick(t);
    }
  }]);
}(p);
s.shadowRootOptions = _objectSpread(_objectSpread({}, m.shadowRootOptions), {}, {
  delegatesFocus: !0
});
s.styles = [i(u), i(b), i(g), i(f)];
s = C([$("ngc-button-card")], s);
export { s as NgcButtonCard };